"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "au_tags-module__container___ZgaRW",
  "placeholder": "au_tags-module__placeholder___HLM4I",
  "tag": "au_tags-module__tag___WZ6fa",
  "key": "au_tags-module__key___sqPPk",
  "value": "au_tags-module__value___zKUiX",
  "delimiter": "au_tags-module__delimiter___DpfuH",
  "quoted": "au_tags-module__quoted___NGkDl"
};
class AuTags extends _react.default.Component {
  static propTypes = {
    tags: T.object,
    className: T.string,
    placeholder: T.string,
    placeholderId: T.string
  };
  render() {
    const {
      tags,
      placeholder,
      placeholderId,
      className
    } = this.props;
    const elements = [];
    if (tags && (0, _keys.default)(tags).length) {
      for (let [key, value] of (0, _entries.default)(tags)) {
        if (key !== '' && value !== '') {
          elements.push( /*#__PURE__*/_react.default.createElement("div", {
            key: `tag_${key}`,
            className: styles.tag,
            title: `${key} : "${value}"`
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: styles.key
          }, key), /*#__PURE__*/_react.default.createElement("span", {
            className: styles.delimiter
          }, ":"), /*#__PURE__*/_react.default.createElement("div", {
            className: styles.quoted
          }, /*#__PURE__*/_react.default.createElement("div", {
            "data-tcl": "AuTags-value",
            className: styles.value
          }, value))));
        }
      }
    } else if (placeholder || placeholderId) {
      elements.push( /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        key: "no_tags_placeholder",
        className: styles.placeholder,
        displayId: placeholderId,
        displayString: placeholder
      }));
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className)
    }, elements);
  }
}
exports.default = AuTags;